export const SIGNUP_PROMO_KEY = 'signup_promo_code';

export const INVALID_PROMO_REDIRECT_URL =
    'https://www.gevme.com/en/request-a-demo/';

export const getStoredSignupPromo = () =>
    sessionStorage.getItem(SIGNUP_PROMO_KEY)?.trim() || '';

export const setStoredSignupPromo = (promo) => {
    if (promo) {
        sessionStorage.setItem(SIGNUP_PROMO_KEY, promo);
    }
};

export const clearStoredSignupPromo = () => {
    sessionStorage.removeItem(SIGNUP_PROMO_KEY);
};

export const appendPromoToSignupPayload = (payload = {}) => {
    const promo = getStoredSignupPromo();

    if (!promo) {
        return payload;
    }

    return {
        ...payload,
        promo,
    };
};
